function openNavigation (nav, overlay) {
  document.body.style.overflowY = 'hidden'

  nav.classList.add('is-active')
  overlay.classList.add('is-active')
}

function closeNavigation (nav, overlay) {
  document.body.style.overflowY = ''

  nav.classList.remove('is-active')
  overlay.classList.remove('is-active')
}

const headerNavigation = document.querySelector('.js-header-navigation')

if (headerNavigation) {
  const openButton = document.querySelector('.js-header-navigation-open')
  const overlay = document.querySelector('.js-header-navigation-overlay')

  openButton.addEventListener('click', () => {
    openNavigation(headerNavigation, overlay)
  })

  overlay.addEventListener('click', () => {
    closeNavigation(headerNavigation, overlay)
  })
}
